import * as z from "zod";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

export const commerceCloudSiteId = z
  .string()
  .trim()
  .regex(
    /^[A-Za-z0-9_-]+$/,
    "Site ID may only contain letters, numbers, _ and -",
  );

/** SFCC locale, e.g. `en_US`, `en-US` or `default`; stored with underscores. */
export const commerceCloudStorefrontLocale = z
  .string()
  .trim()
  .regex(
    /^(default|[a-z]{2,3}([_-][A-Za-z0-9]{2,8})*)$/,
    "Locale must look like en_US or default",
  );

export const updateCommerceCloudSite = {
  name: "updateCommerceCloudSite" as const,
  input: z.object({
    integrationId: commerceCloudIntegrationId,
    siteId: commerceCloudSiteId,
    /**
     * Fallback locale for the storefront embed when the cartridge is not
     * rendering. Null clears it.
     */
    storefrontLocale: commerceCloudStorefrontLocale.nullable(),
  }),
  output: z.null(),
};
